import { StaticProvider } from '@angular/core';
import { UserIdleConfig } from './user-idle.type';
import { USER_IDLE_CONFIG } from './user-idle.token';

export function provideUserIdleConfig(config: UserIdleConfig): StaticProvider[] {
  return [{ provide: USER_IDLE_CONFIG, useValue: config }];
}
